import "../../styles/freelance.css";
import PeaceImg from "../../assets/Peace.jpg";
import PurposeImg from "../../assets/Purpose.jpg";
import HappinessImg from "../../assets/Happiness.jpg";




const freelanceData = {
  introduction: "The Freelance Component empowers South African professionals by providing access to specialized opportunities across various industries. Whether it's contributing to environmental sustainability, advancing scientific research, or driving economic growth, freelancers can find meaningful work tailored to their expertise.",
  sectors: [
    { title: "Peace", description: "Opportunities in Agriculture, Nature Conservation, and Urban & Rural Development.", image: PeaceImg },
    { title: "Purpose", description: "Freelance roles in Science, Research, and Technology.", image: PurposeImg },
    { title: "Happiness", description: "Work in Education, Media & Marketing, and Finance & Investment.", image: HappinessImg },
  ]
};

const Freelance = () => {
  return (
    <div className="freelance">
      <h1>Freelance Opportunities</h1>

      {/* Introduction Section */}
      <section className="intro">
        <p>{freelanceData.introduction}</p>
      </section>

      {/* Sectors Section */}
      <section className="sectors">
        <h2>Freelance Sectors</h2>
        <div className="sectors-grid">
          {freelanceData.sectors.map((sector, index) => (
            <div key={index} className="sector-card">
              <img src={sector.image} alt={sector.title} className="sector-image" />
              <h3>{sector.title}</h3>
              <p>{sector.description}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Freelance;
